import {useEstadoServidor} from '../hooks/useEstadoServidor';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {loadingModal} from 'src/redux-app';
import {EstadoServidor} from '../../bussines/entities/EstadoServidor.entity';
import {TablaScreen} from '../components/TablaScreen';
import {format} from 'date-fns';
import {CopyInfo} from '../components/CopyInfo';

// Columnas de la tabla
const columns = [
   {
      name: '',
      label: '#',
      options: {
         filter: false,
         display: 'true',
         customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
            const rowIndex = tableMeta.rowIndex + 1;
            return rowIndex;
         }
      }
   },
   {
      name: 'servidor',
      label: 'Servidor',
      options: {
         filter: true,
         display: 'true',
      }
   },
   {
      name: 'ip',
      label: 'Ip',
      options: {
         filter: true,
         display: 'true',
         customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
            let time = tableMeta.rowData[4];
            if (typeof time === 'string') {
               time = parseFloat(time.replace(/[^\d.-]/g, ''));
            }
            return codeWithButtonCopy(value, tableMeta.rowData[3], time);
         }
      }
   },
   {
      name: 'estado',
      label: 'Estado',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'tiempo',
      label: 'Tiempo Respuesta (ms)',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'revisadoEn',
      label: 'Revisado En',
      options: {
         filter: true,
         display: 'true',
         customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
            const fecha = new Date(value);
            const tiempoFormateado = format(fecha, 'hh:mm:ss aa');
            return tiempoFormateado;
         }
      }
   },
   {
      name: 'mensaje',
      label: 'Observaciones',
      options: {
         filter: true,
         display: 'true'
      }
   }
];

// Colores para los estados
const red = '#F25050';
const ambar = '#F2930D';
const green = '#00A73B';

// Función para obtener el color según el estado y el tiempo
function codeWithButtonCopy(info: string, estado: string, tiempo: number) {
   const getColor = (estado: string) => {
      if (estado == 'Activo') {
         return tiempo < 200 ? green : ambar;
      } else {
         return red;
      }
   };
   return <CopyInfo info={info} color={getColor(estado)} />;
}


export const ServidoresScreen: React.FC<{}> = ({}) => {
   const today = new Date();
   const dispatch = useDispatch();
   const [isLoading, setIsLoading] = useState(false);
   const {getEstadoServidores} = useEstadoServidor();
   const [data, setData] = useState<EstadoServidor[]>([]);
   const fetchEstadoServidor = async () => {
      setIsLoading(true);
      const result = await getEstadoServidores();
      console.log(result);
      if(result) setData(result);
      setIsLoading(false);
   };

   useEffect(() => {
      fetchEstadoServidor();
   }, []);

   //Modal de espera
   function openWaitModal(load: boolean) {
      dispatch(loadingModal(load));
   }

   useEffect(() => {
      openWaitModal(isLoading);
   }, [isLoading]);

   return (
      <TablaScreen
         columns={columns}
         data={data}
         lastRevision={`${format(today, 'dd/MM/yy')} - ${format(today, 'hh:mm:ss aa')}`}
         onClick={fetchEstadoServidor}
      />
   );
};
